import React from 'react';
import MuiTableBody from '@mui/material/TableBody';

const TableBody = (props) => <MuiTableBody {...props} />;

export default TableBody;
